import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-fp-process',
    templateUrl: './fp-process.component.html',
    styleUrl: './fp-process.component.scss',
    imports: [TranslateModule]
})
export class FpProcessComponent {

}